import React from "react";

export default function Privacy() {
  const styles = {
    body: {
      margin: 0,
      padding: 0,
      fontFamily: "Arial, sans-serif",
      background: "linear-gradient(90deg, #4c3af5, #37435a)",
      color: "white",
      minHeight: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    container: {
      maxWidth: "90%",
      padding: 20,
      background: "rgba(255, 255, 255, 0.1)",
      borderRadius: 10,
      boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
    },
    titleContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: 20,
      marginBottom: 20,
    },
    h1: {
      fontSize: "2rem",
      margin: 0,
      color: "white",
    },
    h2: {
      fontSize: "1.5rem",
      marginTop: 20,
      marginBottom: 10,
    },
    p: {
      fontSize: "1rem",
      lineHeight: 1.5,
      margin: "10px 0",
    },
    a: {
      color: "#ffcc00",
      textDecoration: "none",
    },
    ul: {
      margin: "10px 0 10px 20px",
    },
  };

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <div style={styles.titleContainer}>
          <img
            src="/Assets/Logos/app_logo.png"
            alt="Privacy"
            width={100}
            height="auto"
          />
          <h1 style={styles.h1}>Driving Theory Test Bangla</h1>
        </div>

        <h2 style={styles.h2}>Privacy Policy</h2>
        <p style={styles.p}>
          This Privacy Policy applies to the Driving Theory Test Bangla app,
          published by NUQI Software Limited (“we”, “our”, or “us”).
        </p>

        <h2 style={styles.h2}>1. What Information We Collect</h2>
        <p style={styles.p}>
          We only collect limited personal information, and only during the
          subscription process. This includes:
        </p>
        <ul style={styles.ul}>
          <li>Email address</li>
          <li>Contact number</li>
          <li>Billing address</li>
        </ul>
        <p style={styles.p}>
          We do not collect any other personal information or track user
          behavior within the app.
        </p>

        <h2 style={styles.h2}>2. How We Use Your Information</h2>
        <p style={styles.p}>
          The information collected is used solely for the purpose of processing
          and managing your subscription payment. We do not use your data for
          marketing or profiling.
        </p>

        <h2 style={styles.h2}>3. Sharing of Information</h2>
        <p style={styles.p}>
          We do not sell or share your personal information with third parties.
          The only exception is trusted payment processors who require the data
          to complete your transaction.
        </p>

        <h2 style={styles.h2}>4. Data Security</h2>
        <p style={styles.p}>
          We implement reasonable technical measures to safeguard your personal
          data. However, please note that no method of internet transmission is
          100% secure.
        </p>

        <h2 style={styles.h2}>5. Children's Privacy</h2>
        <p style={styles.p}>
          This app is not intended for children under the age of 13. We do not
          knowingly collect any data from children.
        </p>

        <h2 style={styles.h2}>6. Changes to This Policy</h2>
        <p style={styles.p}>
          We may update this Privacy Policy from time to time. Any significant
          changes will be communicated through the app or website.
        </p>

        <h2 style={styles.h2}>7. Contact Us</h2>
        <p style={styles.p}>
          If you have questions or concerns regarding this policy, please
          contact us at:
          <br />
          <a href="mailto:contact@nuqisoft.com" style={styles.a}>
            contact@nuqisoft.com
          </a>
        </p>

        <h2 style={styles.h2}>8. Account Deletion Support</h2>
        <p style={styles.p}>
          If you experience any issues while trying to delete your account,
          please contact our support team at:
          <br />
          <a href="mailto:contact@nuqisoft.com" style={styles.a}>
            contact@nuqisoft.com
          </a>
        </p>
      </div>
    </div>
  );
}
